import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import TextFieldHookForm from 'components/Common/InputBox/TextFieldHookForm';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';

export const InputRow = ({
  header,
  name,
  isRequired,
  disabled,
  children,
  placeholderLabel,
  restrictCallback,
  autoComplete,
}) => {
  return (
    <>
      <TblRow>
        <TblRowHeader rowHeader={header} isRequired={isRequired} />
        <TblRowTail>
          <TextFieldHookForm
            name={name}
            className="type-full"
            maxLength={50}
            disabled={disabled}
            placeholderLabel={i18n.t(placeholderLabel)}
            restrictCallback={restrictCallback}
            autoComplete={autoComplete}
          />
          {children}
        </TblRowTail>
      </TblRow>
    </>
  );
};
InputRow.propTypes = {
  header: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  placeholderLabel: PropTypes.string,
  autoComplete: PropTypes.string,
  restrictCallback: PropTypes.func,
};
InputRow.defaultProps = {
  isRequired: false,
  disabled: false,
  children: '',
  placeholderLabel: '',
  autoComplete: '',
  restrictCallback: () => {
    return true;
  },
};
export default InputRow;
